export const FilterType = {
  STRING: 'string',
  NUMBER: 'number',
  DATE_RANGE: 'dateRange',
  DATE_TIME_RANGE: 'dateTimeRange',
  BOOLEAN: 'boolean',
  CONSTRAINTS: 'constraints',
} as const;

export type FilterType_Keys = keyof typeof FilterType;
